@if (priority) {
    <div class="vc-task-priority-items-center">
        <vc-icon
            [name]="priorityIconMap.get(priority) ?? ''"
            [color]="priorityColorMap.get(priority) ?? ''"
            size="16px"></vc-icon>
        {{ priority | textRenderer: priorityItemRenderer }}
    </div>
}
